import { salesqueze } from "~/plugins/salesqueze-sdk-browser";

export async function getProducts() {
  const res = await salesqueze.getProducts({}, { description: 1, propertyAttributes: 1 });
  const items = res.data.items;
  const adjustedItems = items.map((v) => {
    for (const attr of v.propertyAttributes) {
      v[attr.key] = attr.value;
    }
    return v;
  })
  return adjustedItems;

}